import qs from "qs";
import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";
import { setLoading } from "../loading/loadingSlice";

// GET ALL ARTICLE
export const getAllArticle = createAsyncThunk("/api/v1/article/admin", async ({ page, limit, search }, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const params = {
      page,
      limit,
      sort: "-updatedAt",
      search,
      searchFields: "title",
    };
    const query = qs.stringify(params, { encode: true });
    const response = await api.get(`/api/v1/article/admin?${query}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching article list:", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error fetching article list";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});

// create article
export const createArticle = createAsyncThunk("/api/v1/article/admin/create", async ({ transformedPayload }, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const response = await api.post(`/api/v1/article/admin`, {
      ...transformedPayload,
    });
    return response.data;
  } catch (error) {
    console.error("Error creating article :", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error creating article";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});

//GET SINGLE ARTICLE ALL DETIALS
export const getArticleDetail = createAsyncThunk("/api/v1/article/admin/{{articleId}}", async ({ userId }, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const response = await api.get(`/api/v1/article/admin/${userId}`);
    return response.data;
  } catch (error) {
    console.error("Error gettting article details:", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error gettting article details";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});

//TOGGLE ACTIVE ARTICLE
export const toggleActiveArticle = createAsyncThunk("api/v1/article/admin/{{articleId}}", async ({ userId }, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const response = await api.delete(`api/v1/article/admin/${userId}`);
    return response.data;
  } catch (error) {
    console.error("Error toggling article:", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error toggling article ";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});

//EDIT ARTICLE
export const editArticle = createAsyncThunk("/api/v1/article/admin/edit", async ({ userId, updatedInfo }, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const response = await api.put(`/api/v1/article/admin/${userId}`, {
      ...updatedInfo,
    });
    return response.data;
  } catch (error) {
    console.error("Error edit article :", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error edit article";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});
